/* eslint-disable import/no-anonymous-default-export */
export default {
  translation: {
    global: {
      title: 'Where Engineering Meets Excellence',
      subtitle:
        'We craft software that moves businesses forward. From strategy to launch, we bring precision, creativity, and deep technical expertise to every project.',
      button: 'Book a free consultation',
    },
    about: {
      title: 'About Us',
      subtitle:
        'A team of engineers, designers, and strategists who believe great software starts with understanding your business inside out.',
    },
    services: {
      title: 'Services',
      subtitle:
        'From first prototype to full-scale product, we build digital solutions that last.',
    },
    contact: {
      title: 'Contact Us',
      subtitle:
        'Let us know what you are working on. We would love to hear about your project and see how we can help.',
    },
    faqs: {
      title: 'FAQs',
      subtitle:
        'Wondering how we work? Here are answers to the questions our clients ask most often. If yours is not listed, just reach out and we will get back to you right away.',
      question1: 'How long does it typically take to build a custom software solution?',
      answer1:
        'Every project is different. A focused MVP might take eight to twelve weeks, while a more complex platform could span several months. During our first conversation, we map out your requirements and give you a realistic timeline so there are no surprises along the way.',
      question2:
        'Do you offer support after the project goes live?',
      answer2:
        'Absolutely. Launching is just the beginning. We offer ongoing maintenance, security updates, and feature enhancements tailored to your needs. Think of us as your long-term technology partner, not just a one-time vendor.',
      question3:
        'How do you handle data security and confidentiality?',
      answer3:
        'We take this very seriously. Our team follows industry best practices for encryption, access control, and secure coding. We are happy to sign NDAs and discuss specific compliance requirements during our initial conversation.',
      question4:
        'Can you integrate with systems we already use?',
      answer4:
        'Yes. We have deep experience connecting with CRMs, payment gateways, ERP systems, and third-party APIs. Smooth integration is always part of the plan, not an afterthought.',
      question5:
        'How do you make sure the end product is easy to use?',
      answer5:
        'We design with real people in mind. That means user research, wireframes, and iterative testing before a single line of production code is written. We also welcome your feedback throughout the process to make sure the final experience feels intuitive and polished.',
      question6: 'What does your project management process look like?',
      answer6:
        'We use agile sprints with regular check-ins so you always know where things stand. You will have a dedicated point of contact, access to our project board, and demos at the end of each sprint. Transparency is non-negotiable for us.',
      question7: 'How do you structure pricing?',
      answer7:
        'We price based on scope and complexity, not guesswork. After our discovery session, you will receive a detailed proposal with clear deliverables and costs. No hidden fees, no surprises.',
    },
    footer: {
      title:
        'We turn bold ideas into polished digital products that help our clients grow. From concept through launch and beyond, Hizelus is your partner in building what matters.',
      userfulLinks: {
        title: 'Quick Links',
        home: 'Home',
        about: 'About Us',
        services: 'Our Services',
        contact: 'Contact Us',
        faqs: 'FAQs',
      },
      contact: {
        title: 'Get in Touch',
        address: 'Wandsbeker Chaussee 212, 22089 Hamburg',
        phone: '+4917642056661',
        email: 'contact@hizelus.com',
      },
      social: {
        title: 'Social',
        facebook: 'Facebook',
        twitter: 'Twitter',
        instagram: 'Instagram',
        linkedin: 'Linkedin',
      },
    },
    header: {
      home: 'Home',
      about: 'About Us',
      services: 'Our Services',
      contact: 'Contact Us',
      faqs: 'FAQs',
      jobs: 'Trainings',
    },
    coreServices: {
      title: 'What We Do Best',
      subtitle:
        'We bring together deep technical skill and a sharp eye for design to deliver solutions that work beautifully and scale reliably. From AI-powered products to bulletproof security, our team covers the full spectrum.',
      service1: {
        title: 'Design',
        description:
          'Great products start with thoughtful design. We create interfaces that look stunning and feel effortless, from user flows and wireframes to pixel-perfect screens that bring your brand to life.',
      },
      service2: {
        title: 'Mobile Development',
        description:
          'We build native and cross-platform apps that people actually enjoy using. Fast performance, clean architecture, and seamless experiences on both iOS and Android.',
      },
      service3: {
        title: 'Web Development',
        description:
          'Whether it is a marketing site or a complex web application, we deliver fast, accessible, and responsive solutions built with modern frameworks and battle-tested best practices.',
      },
      service4: {
        title: 'Branding',
        description:
          'Your brand is more than a logo. We work with you to define your visual identity, tone of voice, and design language so every touchpoint feels cohesive and memorable.',
      },
      service5: {
        title: 'Data Engineering',
        description:
          'Good decisions start with good data. We design pipelines, build warehouses, and set up dashboards that turn raw information into actionable insight for your team.',
      },
      service6: {
        title: 'Artificial Intelligence',
        description:
          'We help businesses harness AI to automate workflows, uncover hidden patterns, and build intelligent products. From machine learning models to conversational agents, we turn data into competitive advantage.',
      },
      service7: {
        title: 'Cyber Security',
        description:
          'Your digital assets deserve serious protection. We conduct security audits, build secure architectures, and implement threat detection systems that keep your business safe around the clock.',
      },
      more_services: {
        text: 'Explore all services',
      },
    },
    feedBack: {
      title: 'What Our Clients Say',
      step1: {
        name: 'Philipp Schneiderwind',
        position: 'CEO, Company',
        feedback:
          '"Hizelus completely transformed our web presence. The team understood our vision from day one and delivered a site that not only looks exceptional but genuinely drives results. Their attention to detail and professionalism set them apart from anyone we have worked with before."',
      },
      step2: {
        name: 'Ogbonna Chinedu Emmanuel',
        position: 'CEO, Company',
        feedback:
          '"Our mobile app went from concept to App Store in record time, and the quality speaks for itself. Hizelus took the time to really understand our users. The result is an app our customers love and our competitors envy."',
      },
      step3: {
        name: 'Emma Duru',
        position: 'CEO, Company',
        feedback:
          '"Choosing Hizelus for our consulting engagement was one of the smartest moves we made. Their team brought clarity to a complex situation, helped us streamline our processes, and identified growth opportunities we had completely overlooked. Highly recommended."',
      },
    },
    ourWork: {
      title: 'Our Work',
      subtitle:
        'We measure our success by the impact we create for our clients. Every project in our portfolio represents a real business challenge met with thoughtful engineering and design.',
      work1: {
        title: 'Project 1',
        subtitle: 'A digital product that redefined how users interact with the platform.',
      },
      work2: {
        title: 'Project 2',
        subtitle: 'An end-to-end solution built for scale and reliability.',
      },
      work3: {
        title: 'Project 3',
        subtitle: 'Bringing a bold brand vision to life through code and creativity.',
      },
      work4: {
        title: 'Project 4',
        subtitle: 'A mobile experience designed around the needs of real users.',
      },
      work5: {
        title: 'Project 5',
        subtitle: 'Data-driven insights that transformed decision-making.',
      },
      work6: {
        title: 'Project 6',
        subtitle: 'A complete digital overhaul for a growing enterprise.',
      },
    },
    booking: {
      title: 'Build Something Remarkable',
      subtitle:
        'Ready to bring your next idea to life? Book a free consultation and let us show you what is possible. We will listen, ask the right questions, and put together a plan that fits your goals and your budget.',
      button: 'Book a free consultation',
    },
    coreValue: {
      title: 'Our Core Values',
      subtitle:
        'Everything we build is guided by a set of principles we take seriously. Integrity, innovation, and excellence are not just words on a wall. They shape how we work, how we communicate, and how we deliver.',
      value1: {
        title: 'Integrity',
        subtitle:
          'We say what we mean and deliver what we promise. Honest communication and transparency are the foundation of every client relationship we build.',
      },
      value2: {
        title: 'Innovation',
        subtitle:
          'Technology moves fast, and so do we. We stay curious, embrace new tools and approaches, and bring fresh thinking to every challenge.',
      },
      value3: {
        title: 'Teamwork',
        subtitle:
          'Great work happens when talented people collaborate openly. We bring together diverse perspectives and skills to produce results no one could achieve alone.',
      },
      value4: {
        title: 'Excellence',
        subtitle:
          'Good enough is never enough. We hold ourselves to the highest standard in code quality, design craft, and client communication.',
      },
      value5: {
        title: 'Customer Focus',
        subtitle:
          'Your success is our success. We listen carefully, adapt quickly, and make sure every decision serves your business goals.',
      },
    },
    whoWeAre: {
      title: 'Who We Are',
      subtitle:
        'Hizelus Engineering is a Hamburg-based software consultancy built by engineers who care about craft. We partner with startups and established businesses alike to design, build, and scale digital products that make a real difference. Our approach is collaborative, our standards are high, and our focus is always on delivering lasting value.',
    },
    whyWeDoIt: {
      title: 'Why We Do This',
      subtitle:
        'We started Hizelus because we believe every business deserves access to world-class software. Too many companies settle for mediocre technology because the right partner was never there. We are here to change that, one project at a time.',
    },
    team: {
      title: 'The Team Behind Hizelus',
      subtitle:
        'Our strength lies in the people who show up every day with passion, skill, and a genuine desire to build something great. Meet the team that makes it happen.',
      member1: {
        name: 'Hilary Ogalagu',
        position: 'CEO, Software Engineer',
      },
      member2: {
        name: 'Narender Vaddepelly',
        position: 'CTO, Senior Software Developer',
      },
      member3: {
        name: 'Kenneth Obi',
        position: 'FullStack Developer',
      },
      member4: {
        name: 'Vanessa Laturnus',
        position: 'Content Manager',
      },
      member5: {
        name: 'John Doe',
        position: 'CEO, Company',
      },
      member6: {
        name: 'John Doe',
        position: 'CEO, Company',
      },
    },
    stayConnected: {
      title: 'Stay Connected',
      subtitle:
        'Join our community to get insights on technology trends, product development, and what we are building next. No spam, just the good stuff.',
      button: 'Subscribe',
    },
    OurServices: {
      title: 'OUR SERVICES',
      title1: 'Design',
      subtitle1:
        'We believe beautiful design drives real results. Our designers collaborate closely with you to craft interfaces and experiences that capture your brand, engage your users, and set you apart from the competition.',
      title2: 'Mobile Development',
      subtitle2:
        'Smartphones are where your customers live. We build fast, reliable, and elegant mobile apps for iOS and Android that keep people coming back.',
      title3: 'Web Development',
      subtitle3:
        'Your website is often the first impression you make. We combine clean code with beautiful design to create responsive, high-performance web experiences that convert visitors into customers.',
      title4: 'Branding',
      subtitle4:
        'A strong brand is built on consistency and clarity. From logo design to messaging frameworks, we help you define a visual identity that resonates with your audience and stands the test of time.',
      title5: 'Digital Marketing',
      subtitle5:
        'We help you reach the right people at the right time. Through strategic digital campaigns, content planning, and analytics, we turn your online presence into a growth engine.',
      title6: 'Consulting',
      subtitle6:
        'Not sure where to start? Our consultants bring decades of combined experience to help you make smart technology decisions, plan your roadmap, and avoid costly mistakes.',
      title7: 'Data Management',
      subtitle7:
        'Your data is one of your most valuable assets. We build the infrastructure to collect, store, analyze, and act on it, so you can make faster and smarter decisions.',
      title8: 'Artificial Intelligence',
      subtitle8:
        'We build AI solutions that actually solve problems. Whether you need predictive models, natural language processing, computer vision, or intelligent automation, we design and deploy AI systems that integrate seamlessly into your business and deliver measurable results.',
      title9: 'Cyber Security',
      subtitle9:
        'In a world where threats evolve daily, your security needs to stay ahead. We provide comprehensive security assessments, penetration testing, secure architecture design, and real-time monitoring to protect your digital infrastructure, your data, and your reputation.',
    },
    HowWeDoIt: {
      title: 'How We Bring Your Vision to Life',
      subtitle:
        'A proven process refined over years of delivering successful projects.',
      step1: {
        title: 'Define Your Vision',
        subtitle:
          'We sit down with you to understand your goals, your audience, and your market. Together, we shape a clear product concept that aligns with where your business is headed.',
      },
      step2: {
        title: 'Validate the Idea',
        subtitle:
          'Before building, we test. Through research, prototyping, and user feedback, we make sure your idea has strong market fit and is worth the investment.',
      },
      step3: {
        title: 'Build the Product',
        subtitle:
          'Our engineers and designers work in agile sprints to bring your product to life. You see progress every week, and your feedback shapes every iteration.',
      },
      step4: {
        title: 'Launch with Confidence',
        subtitle:
          'We help you plan a launch that maximizes impact. From deployment to marketing support, we make sure your product enters the market strong.',
      },
      step5: {
        title: 'Reduce Risk at Every Step',
        subtitle:
          'Risk management is built into everything we do. We identify potential issues early, test rigorously, and follow best practices to keep your project on track.',
      },
    },
    contactForm: {
      title: 'Contact Us',
      title1: 'YOUR DETAILS',
      subtitle:
        'I would like to receive updates and insights from Hizelus Engineering',
      button: 'Submit',
    },
    contactUs: {
      title: 'Contact Us',
      subtitle:
        'Whether you have a specific project in mind or just want to explore what is possible, we are here for it. Reach out by phone, email, or fill in the form below. We typically respond within one business day.',
      address: 'Address',
      address1: 'Wandsbeker Chaussee 212, 22089 Hamburg, Germany',
      phone: 'Phone',
      phone1: '+4917642056661',
      email: 'Email',
      email1: 'hilary@hizelus.com',
      title1: 'Let us build something together',
      subtitle1:
        'We would love to learn about your project. Tell us what you are working on, and we will put together a plan that makes sense for your timeline and budget.',
      button: 'Submit',
      title3: 'You can also reach us directly',
    },
    whatsNext: {
      title: 'What Happens Next?',
      step1: {
        title: 'Initial Conversation',
        subtitle:
          'We start with a relaxed conversation about your project, your goals, and your timeline. No commitments, just a genuine discussion about what you need.',
      },
      step2: {
        title: 'Detailed Proposal',
        subtitle:
          'Based on our conversation, we prepare a clear proposal outlining scope, timeline, and investment. You will know exactly what to expect before we start.',
      },
      step3: {
        title: 'Deep-Dive Discovery',
        subtitle:
          'Once we agree to move forward, we conduct thorough requirements sessions. This is where we get into the details that make the difference between good and great.',
      },
      step4: {
        title: 'Design & Architecture',
        subtitle:
          'Our designers and architects create the blueprint for your solution. Wireframes, prototypes, and technical plans all come together in this phase.',
      },
      step5: {
        title: 'Development & Testing',
        subtitle:
          'We build in focused sprints with continuous testing. You get regular demos and the opportunity to give feedback at every stage.',
      },
      step6: {
        title: 'Close Collaboration',
        subtitle:
          'Your input matters at every step. We share progress openly, welcome honest feedback, and adjust course as needed to get it right.',
      },
      step7: {
        title: 'Delivery & Support',
        subtitle:
          'When your product is ready, we handle deployment, provide thorough documentation, and stay available for ongoing support and future enhancements.',
      },
    },
    aboutUsStatus: {
      customer: 'Happy Clients',
      team: 'Team Members',
      products: 'Products Launched',
      community: 'Community Members',
    },
  },
}
